import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import get from 'lodash/get';
import cn from 'classname';
import PaginationButton from './paginationButton';
import FillPriorityForm from './fill-priority-form';

const Table = ({ table, intl, remove, can, fetchMore, toggleSwitchToOrder, sortByColumn, fetchData }) => (
	<div className="table-container">
		<table className="simple-table additional-offers-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr className="additional-offers-row">
					<th
						className={cn({
							'show-sort-sign-after-title': true,
							'title-col': true,
							active: true
						})}
					>
						<span className="th-title">{intl('Title')}</span>
						<span>
							<p className="order-action-btn order-action-btn--reorder" onClick={e => {
								e.stopPropagation();
								toggleSwitchToOrder();
							}}>
								<span>{intl('Reorder')}</span>
							</p>
						</span>
					</th>
					<th className="short-col">{intl('Country')}</th>
					<th className="short-col">{intl('Status')}</th>
					<th className="short-col">{intl('1C Status')}</th>
					<th className="short-col">{intl('Priority')}</th>
					<th className="">{intl('Tags')}</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'stock' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'stock' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'stock'
						})}
						title={'Stock'}
						onClick={sortByColumn.bind(null, 'stock')}
					>
						{intl('Stock')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'approves_plan'
						})}
						title={'Stock in days'}
						onClick={sortByColumn.bind(null, 'approves_plan')}
					>
						{intl('STOCK IN DAYS')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'profit middle-col': true,
							'desc': table.sortedColumn.index === 'profit_crm' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'profit_crm' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'profit_crm'
						})}
						title={'Средняя по лидам маржа в USD'}
						onClick={sortByColumn.bind(null, 'profit_crm')}
					>
						{intl('AV. PROFIT')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'free_leads' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'free_leads' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'free_leads'
						})}
						title={'Свободная капа по ГЕО'}
						onClick={sortByColumn.bind(null, 'free_leads')}
					>
						{intl('FREE LEADS IN GEO')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'approves_plan'
						})}
						title={'Товарная капа до новой доставки'}
						onClick={sortByColumn.bind(null, 'approves_plan')}
					>
						{intl('CAPACITY OF LEADS')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'approves_plan'
						})}
						title={'Ср кол-во лидов за 3 дня'}
						onClick={sortByColumn.bind(null, 'approves_plan')}
					>
						{intl('AVERAGE LEADS')}
					</th>
					<th
						className={cn({
							'sort-header': true,
							'middle-col': true,
							'desc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'desc',
							'asc': table.sortedColumn.index === 'approves_plan' && table.sortedColumn.direction === 'asc',
							'active': table.sortedColumn.index === 'approves_plan'
						})}
						title={'Свободная капа для запуска'}
						onClick={sortByColumn.bind(null, 'approves_plan')}
					>
						{intl('Max leads in days')}
					</th>
					<th className="" title={'Срок годности товара'}>{intl('EXP. Date')}</th>
					<th />
				</tr>
			</thead>
			<tbody className="simple-table__body">
				{ table.rows.map(row => (
					<tr key={`${row.offer_id}_${row.location_id}`} className="additional-offers-row">
						<td className="offer_title">
							<span className="title__text">
								{row.title}
							</span>
						</td>
						<td className="short-col">
							<span> {row.country_code}{' '} </span>
						</td>
						<td className="short-col">
							<span> {row.status} </span>
						</td>
						<td className="short-col">
							<span> {row.status_1c} </span>
						</td>
						<td className="short-col position-relative priority-col">
							<FillPriorityForm row={row} fetchData={fetchData}/>
							<span> {row.priority} </span>
						</td>
						<td>
							{row.tags && row.tags.length ? row.tags.join(',') : '-'}
						</td>
						<td>
							{row.products_stock}
						</td>
						<td>
							{Math.round(row.remaining_quantity_in_days)}
						</td>
						<td className="profit">
							{Math.round(row.profit_crm * 10) / 10}
						</td>
						<td className={cn({ 'negative-value': row.free_leads && Number(row.free_leads) < 0})}>
							{row.free_leads}
						</td>
						<td>
							{Math.round(row.products_stock /(
								(row.approve_count/row.total_count) * row.product_production_cycle * row.product_quantity_per_one_lead
							))}
						</td>
						<td>
							{Math.round(row.average_total_count/3)}
						</td>
						<td>
							{Math.round(row.products_stock /(
								(row.approve_count/row.total_count) * row.product_production_cycle * row.product_quantity_per_one_lead
							)) - Math.round(row.average_total_count/3)}
						</td>
						<td>
							{row.max_expiration_date}
						</td>
						<td className="actions">
							<Link className="action_edit" to={`/programs/editor/${row.id}`}/>
							{can('edit') && (
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										confirm(`${intl('Remove offer')} ${row.title}?`) && remove(row.id );
									}} className="action_delete" />
							)}
						</td>
					</tr>
				)) }
			</tbody>
		</table>
		{table.totalRows < get(table.rows, '[0].total_count', 0) && (
			<div className="table-container__navigation">
				<PaginationButton intl={intl} fetchMore={fetchMore} />
			</div>
		)}
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func,
	toggleSwitchToOrder: PropTypes.func,
	lists: PropTypes.object
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table-additional/table.js